import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '@common/services/AuthService/AuthService';
import { ModalService } from '@common/services/ModalService/ModalService';
import { AreaService } from '@common/services/AreaService/AreaService';
import { ProgressService } from '@common/services/ProgressService/ProgressService';
import { SortableTableComponent } from '@common/components/SortableTableComponent/sortableTable.component';
import { AreaUpdate } from '@common/models/areaUpdate.model';
import { QueryParametersUpdate } from '@common/models/queryParametersUpdate.model';
import { Field } from '@common/models/field.model';
import { QueryParameters } from '@common/models/queryParameters.model';
import { AreaUpdatesData } from '@common/models/areaUpdatesData.model';
import { ProgressData } from '@common/models/progressData.model';
import { AreaSummariesData } from '@common/models/areaSummariesData.model';
import { AreaAcceptResponse } from '@common/models/areaAcceptResponse.model';

@Component({
  templateUrl: './dashboardView.component.html',
  styleUrls: ['./dashboardView.component.scss'],
})
export class DashboardViewComponent implements OnInit {
  public areaUpdatesData: AreaUpdatesData = {
    areaUpdates: [],
    areaUpdatesNumber: 0,
  };
  public progressData: ProgressData = {
    today: null,
    day: {
      date: null,
      value: null,
    },
    week: {
      date: null,
      value: null,
    },
  };
  public areaSummariesData: AreaSummariesData = {
    areaSummaries: [],
    areaSummariesNumber: 0,
  };
  dataFetchingTimeout;
  @ViewChild('areaUpdatesTableComponent') areaUpdatesTableComponent: SortableTableComponent;
  @ViewChild('areaSummariesTableComponent') areaSummariesTableComponent: SortableTableComponent;

  areaUpdatesQueryParameters: QueryParameters = {
    query: '',
    orderBy: '',
    sortOrder: 'ASC',
    page: 1,
  };

  areaSummariesQueryParameters: QueryParameters = {
    query: '',
    orderBy: '',
    sortOrder: 'ASC',
    page: 1,
  };

  public areaUpdatesFields: Field[] = [
    { shortName: 'clientName', fullName: 'client', type: 'string', sortable: true, width: '18%' },
    { shortName: 'buildingName', fullName: 'buildingName', type: 'string', sortable: true, width: '18%' },
    { shortName: 'floor', fullName: 'floor', type: 'string', sortable: true, width: '10%', textAlign: 'center' },
    { shortName: 'areaName', fullName: 'areaName', type: 'string', sortable: true, width: '28%' },
    { shortName: 'lastChangeDate', fullName: 'lastChangeDate', type: 'date', sortable: true, width: '15%' },
  ];

  public areaSummariesFields: Field[] = [
    { shortName: 'clientName', fullName: 'client', type: 'string', sortable: true, width: '18%' },
    { shortName: 'employees', fullName: 'employees', type: 'employees', sortable: true, width: '19%' },
    { shortName: 'areaName', fullName: 'areaName', type: 'string', sortable: true, width: '19%' },
    { shortName: 'progress', fullName: 'progress', type: 'progress-indicator', sortable: false, width: '21%' },
    { shortName: 'date', fullName: 'date', type: 'string', sortable: true, width: '12%' },
  ];

  constructor(
    public authService: AuthService,
    public modalService: ModalService,
    public progressService: ProgressService,
    public areaService: AreaService,
  ) {}

  ngOnInit() {
    this.getAreaUpdates();
    this.getProgress();
    this.getAreaSummaries();
  }

  getAreaUpdates(): void {
    this.areaService.getAreaUpdates(this.areaUpdatesQueryParameters)
      .subscribe(
        (data: AreaUpdatesData) => {
          this.areaUpdatesData = data;
          if (this.areaUpdatesTableComponent) {
            this.areaUpdatesTableComponent.hideSpinner();
          }
        },
        error => this.authService.handleRequestError(error, this.getAreaUpdates.bind(this)),
      );
  }

  getProgress(): void {
    this.progressService.getProgress()
      .subscribe(
        (data: ProgressData) => {
          this.progressData = data;
        },
        error => this.authService.handleRequestError(error, this.getProgress.bind(this)),
      );
  }

  getAreaSummaries(): void {
    this.areaService.getAreaSummaries(this.areaSummariesQueryParameters)
      .subscribe(
        (data: AreaSummariesData) => {
          this.areaSummariesData = data;
          if (this.areaSummariesTableComponent) {
            this.areaSummariesTableComponent.hideSpinner();
          }
        },
        error => this.authService.handleRequestError(error, this.getAreaSummaries.bind(this)),
      );
  }

  updateAreaUpdatesQueryParameters($event: QueryParametersUpdate): void {
    this.areaUpdatesQueryParameters = Object.assign(this.areaUpdatesQueryParameters, $event);
    this.getDataWithTimeout(this.getAreaUpdates.bind(this));
  }

  updateAreaSummariesQueryParameters($event: QueryParametersUpdate): void {
    this.areaSummariesQueryParameters = Object.assign(this.areaSummariesQueryParameters, $event);
    this.getDataWithTimeout(this.getAreaSummaries.bind(this));
  }

  acceptAreaUpdate(areaUpdate: AreaUpdate): void {
    this.areaService.acceptAreaUpdate(areaUpdate.id)
      .subscribe(
        (res: AreaAcceptResponse) => {
          this.getDataWithTimeout(this.getAreaUpdates.bind(this));
        },
        (err) => {
          this.modalService.openModal({ type: 'errorOccurred' });
        },
    );
  }

  getDataWithTimeout(fn): void {
    clearTimeout(this.dataFetchingTimeout);
    this.dataFetchingTimeout = setTimeout(fn, 500);
  }

  generateParamsForAreaSummaries(item) {
    let params = {};

    if (item.employees[0] && item.employees[0].key && item.date) {
      params = {
        employeeKey: item.employees[0].key,
        date: item.date,
      };
    }

    return params;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/views/dashboardView/dashboardView.component.ts